export default {
  PRINT_REQUEST_TABLET: 'PRINT_REQUEST_TABLET',
  UPDATE_SOCKET_RESERVE: 'UPDATE_SOCKET_RESERVE',
  NEW_RESERVE_SUBMITTED_NOTIFICATION: 'NEW_RESERVE_SUBMITTED_NOTIFICATION',
  RESERVEـREQUESTS_AUTOMATICALLY_APPROVED_NOTIFICATION:
    'RESERVEـREQUESTS_AUTOMATICALLY_APPROVED_NOTIFICATION',

  GET_MY_UNREAD_NOTIFICATION: 'GET_MY_UNREAD_NOTIFICATION',
  GET_MY_UNREAD_NOTIFICATION_LOADING: 'GET_MY_UNREAD_NOTIFICATION_LOADING',
  GET_MY_UNREAD_NOTIFICATION_SUCCESS: 'GET_MY_UNREAD_NOTIFICATION_SUCCESS',
  GET_MY_UNREAD_NOTIFICATION_FAILED: 'GET_MY_UNREAD_NOTIFICATION_FAILED',
  GET_MY_UNREAD_NOTIFICATION_REJECT: 'GET_MY_UNREAD_NOTIFICATION_REJECT',

  PUT_READ_NOTIFICATION: 'PUT_READ_NOTIFICATION',
  PUT_READ_NOTIFICATION_LOADING: 'PUT_READ_NOTIFICATION_LOADING',
  PUT_READ_NOTIFICATION_SUCCESS: 'PUT_READ_NOTIFICATION_SUCCESS',
  PUT_READ_NOTIFICATION_FAILED: 'PUT_READ_NOTIFICATION_FAILED',
  PUT_READ_NOTIFICATION_REJECT: 'PUT_READ_NOTIFICATION_REJECT',
};
